/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法url */
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/** 合法的*://*和格式URL */
export function schemaAndURL(textval) {
  const urlregex = /^\w+:\/\/.+$/
  let hasOk = urlregex.test(textval)
  if (hasOk) {
    textval = textval || ''
    const urlList = textval.split('?')[0].split('&')[0].split('://')
    urlList.forEach((item) => {
      if (item.trim() === '') {
        hasOk = false
      }
    })
  }
  return hasOk
}

// 验证密码符合规则
export function validatePassWord(val) {
  const reg = /^[0-9a-zA-Z]{6,18}$/
  return reg.test(val)
}

// 验证账号符合规则
export function validateAccountNumber() {
  const reg = /^[0-9a-zA-Z]+$/
  return reg.test()
}

/* 非负整数 */
export function validateIsNumber(str) {
  const reg = /^\d+?$/
  return reg.test(str)
}

/* 小写字母 */
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母 */
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母 */
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/* 校验非负数 */
export function isIntiger(rule, value, callback) {
  // if (/^[1-9][0-9]*$/g.test(value)) {
  if (/^[0-9]*$/g.test(value)) {
    callback()
    return
  }
  callback(new Error('请输入正整数'))
}

/* 校验可精确到两位小数 */
export function isDecimal(rule, value, callback) {
  if (/^\d+(\.\d{1,2})?$/g.test(value)) {
    callback()
  } else {
    callback(new Error('请输入数字，可精确两位小数'))
  }
}

/* 校验中英文非负数 */
export function isChineseAlphabetsInteger(rule, value, callback) {
  if (/^[\u4e00-\u9fa5A-Za-z0-9]*$/g.test(value)) {
    callback()
    return
  }
  callback(new Error('请输入中英文和数字'))
}

/* 校验 URL */
// 链接必填的验证，请自行在rule中多写一下，该校验方法只验证链接是否合法
export function isURL(rule, value, callback) {
  if (!value) {
    callback()
  }
  if (validateURL(value)) {
    callback()
    return
  }
  callback(new Error(rule.msg || '格式错误，请重新输入'))
}

/* 校验*://*链接地址 */
export function isSchemaAndURL(rule, value, callback) {
  if (schemaAndURL(value) || !value) {
    callback()
    return
  }
  callback(new Error(rule.msg || '格式错误，请重新输入'))
}
/** 新版弹窗&新版弹窗支持2种链接 */
export function dobuleUrlValid(rule, value, callback) {
  if (!value) {
    callback()
  }
  if (validateURL(value) || schemaAndURL(value)) {
    callback()
    return
  }
  callback(new Error(rule.msg || '格式错误，请重新输入'))
}

/* 校验偶数  */
export function isEvenNumber(rule, value, callback) {
  if (value && value % 2 !== 0) {
    callback(new Error('请输入偶数'))
    return
  }
  callback()
}

/* 校验两位小数， 末尾为偶数  */
export function isEndWithEven(rule, value, callback) {
  if (value) {
    const Decimal = value.toFixed(2)
    if (!/[02468]+$/g.test(Decimal)) {
      callback(new Error(' '))
      return
    }
  }
  callback()
}

/* 校验第一个字符是否中文 */
export function isFirstLetterChineseWithAlphabetsInteger(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入'))
    return
  }
  if (!/^[\u4e00-\u9fa5]*$/g.test(value.substr(0, 1))) {
    callback(new Error('标题首字符仅限汉字；首字符外可输入中文、英文、数字；'))
    return
  }
  if (/^[\u4e00-\u9fa5A-Za-z0-9]*$/g.test(value)) {
    callback()
    return
  }
  callback(new Error('仅限输入中文、英文和数字'))
}

/* 仅限汉字、数字和英文字符  */
export function checkName(rule, value, callback) {
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
  if (!reg.test(value)) {
    callback(new Error('仅限输入汉字、数字和英文'))
    return
  }
  callback()
}

// 是否是汉字 true是，false不是
export function isChineseCharacters(value) {
  const reg = /^[\u4e00-\u9fa5a]*$/
  let newVal = value || ''
  newVal = String(newVal)
  return reg.test(newVal || '')
}
// 手机号
export function validMobile(str) {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(str)
}

/* 只能输入中文和英文 */
export function isChineseAndEnglish(str) {
  const reg = /^[a-zA-Z\u4e00-\u9fa5]+$/
  return reg.test(str)
}

export function isChinese(rule, value, callback) {
  const reg = /^[\u4e00-\u9fa5]+$/
  let newVal = value || ''
  newVal = String(newVal)
  if (reg.test(newVal)) {
    return callback()
  } else {
    return callback(new Error(rule.msg || rule.message || '仅支持输入中文'))
  }
}

/** 是否是表情包 */
export const isEmojiCharacter = (substring = '') => {
  substring = substring || ''
  const emoryList = ['🦢', '🎬', '👏', '🐯', '🌹', '😄', '🉑️', '👀', '👎', '🈚️']
  let hasEmory = false
  emoryList.forEach((emory) => {
    if (substring.includes(emory)) {
      hasEmory = true
    }
  })
  if (hasEmory) {
    return hasEmory
  }
  for (let i = 0; i < substring.length; i++) {
    const hs = substring.charCodeAt(i)
    if (hs === 65039) { // 新表情都喊有一个65029的值
      return true
    } else if (hs >= 0xd800 && hs <= 0xdbff) {
      if (substring.length > 1) {
        const ls = substring.charCodeAt(i + 1)
        const uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000
        if (uc >= 0x1d000 && uc <= 0x1f77f) {
          return true
        }
      }
    } else if (substring.length > 1) {
      const ls = substring.charCodeAt(i + 1)
      if (ls === 0x20e3) {
        return true
      }
    } else if (hs >= 0x2100 && hs <= 0x27ff) {
      return true
    } else if (hs >= 0x2B05 && hs <= 0x2b07) {
      return true
    } else if (hs >= 0x2934 && hs <= 0x2935) {
      return true
    } else if (hs >= 0x3297 && hs <= 0x3299) {
      return true
    } else if (hs === 0xa9 || hs === 0xae || hs === 0x303d || hs === 0x3030 ||
        hs === 0x2b55 || hs === 0x2b1c || hs === 0x2b1b ||
        hs === 0x2b50) {
      return true
    }
  }
}

export function validateTel(str) {
  const reg = /^[1]([3-9])[0-9]{9}$/
  return reg.test(str)
}

// 通用数字正则
export function validateNumber(str, cb) {
  const reg = /^[0-9]*$/
  str = str && typeof str === 'string' ? str.trim() : ''
  if (reg.test(str)) {
    cb(str)
  } else {
    cb()
  }
}

/* 司机端版本号 */
export function validateNumberAndPoint(str) {
  const reg = /^([1-9]+)(.(\d+)){3}$/
  return reg.test(str)
}


/* 验证车牌号 */
export function validateCarPlateNo(str) {
  const reg = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/
  return reg.test(str)
}

/* 支持动态配置输入整数位数和是否需要小数点能力，不能输入多个0 */
export const limitMoreZero = (value, cb, len = 9, isNeedDecimals = true) => {
  const reg = new RegExp(`^(0|([1-9][0-9]{0,${len}}))${isNeedDecimals ? '(\\.\\d{0,2})?' : ''}$`, 'g')
  // console.log('---- reg is ----', reg)
  if (reg.test(value) || value === '') {
    cb(value)
  } else {
    limitMoreZero(value.substr(0, value.length - 1), cb, len, isNeedDecimals)
  }
}
// 限制输入18位的数字
export const limitInteger18 = (value, cb, limit = 18) => limitMoreZero(value, cb, limit, false)
/* 支持动态配置是否需要小数点能力，不能输入多个0  最大值100 适合 百分比 */
export const limitMoreZeroByPercent = (value, cb, isNeedDecimals = true) => {
  // 正则不会写了，只能加在这里了。
  if (value.indexOf('100') > -1) {
    cb('100')
    return
  }
  const reg = new RegExp(`^(0|([1-9][0-9]{0,1}|100))${isNeedDecimals && '(\\.\\d{0,2})?'}$`, 'g')
  if (reg.test(value) || value === '') {
    cb(value)
  } else {
    limitMoreZeroByPercent(value.substr(0, value.length - 1), cb, isNeedDecimals)
  }
}

// 校验min-max之间的数字
export const validatorInterest = (rule, value, callback) => {
  const { min = 0, max = 10, integer = false } = rule
  if (rule.required === true) {
    if (value === '') {
      return callback(new Error('请输入'))
    }
  }
  let reg = /^[0-9]+(\.[0-9]{1,2})?$/
  if (integer) {
    reg = /^\d+$/
  }
  if ((reg.test(value) && (value >= min && value <= max)) || !value) {
    return callback()
  }
  callback(new Error(integer ? `请输入${min}-${max}之间的整数` : `请输入${min}-${max}之间的数字，小数不超两位`))
}
